document.addEventListener('DOMContentLoaded', () => {
  // Always leave content visible if the animation library fails to load.
  if (typeof window.gsap === 'undefined' || typeof window.ScrollTrigger === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger);

  const nav = document.getElementById('nav');
  if (nav) ScrollTrigger.create({start:'top -80', end:99999, toggleClass:{targets:nav, className:'scrolled'}});

  const starSVG = `<svg viewBox="0 0 24 24" fill="none"><path d="M12 0L14.8 9.2L24 12L14.8 14.8L12 24L9.2 14.8L0 12L9.2 9.2L12 0Z" fill="currentColor"/></svg>`;
  function seedStars(containerId, count, sizeRange, region){
    const el = document.getElementById(containerId);
    if(!el) return [];
    const stars = [];
    for(let i=0;i<count;i++){
      const s = document.createElement('div');
      s.className = 'star'; s.innerHTML = starSVG;
      const size = sizeRange[0] + Math.random()*(sizeRange[1]-sizeRange[0]);
      s.style.width = size+'px'; s.style.height = size+'px';
      s.style.left = (region.xMin + Math.random()*(region.xMax-region.xMin)) + '%';
      s.style.top = (region.yMin + Math.random()*(region.yMax-region.yMin)) + '%';
      el.appendChild(s); stars.push(s);
    }
    return stars;
  }

  const heroStars = seedStars('starLayerHero', 13, [8,20], {xMin:5,xMax:95,yMin:5,yMax:85});
  gsap.set(heroStars, {scale:0, rotation:() => gsap.utils.random(-90,90), opacity:0});
  gsap.to(heroStars, {opacity:() => gsap.utils.random(0.4,0.9), scale:1, rotation:0, duration:1.2, ease:'back.out(2)', stagger:{each:0.06, from:'random'}, delay:0.3});
  heroStars.forEach(s=>{ gsap.to(s, {y:'+='+gsap.utils.random(-18,18), x:'+='+gsap.utils.random(-14,14), duration:gsap.utils.random(4,7), repeat:-1, yoyo:true, ease:'sine.inOut', delay:gsap.utils.random(0,2)}); });
  gsap.to(heroStars, {y:(i)=>-100-i*14, ease:'none', scrollTrigger:{trigger:'#hero', start:'top top', end:'bottom top', scrub:1}});
  gsap.to('#motifHero', {rotation:18, ease:'none', scrollTrigger:{trigger:'#hero', start:'top top', end:'bottom top', scrub:1}});
  gsap.to('.hero-bg', {y:110, ease:'none', scrollTrigger:{trigger:'#hero', start:'top top', end:'bottom top', scrub:1}});
  gsap.from('.hero-content > *', {y:40, opacity:0, duration:1, stagger:0.12, ease:'power3.out', delay:0.2});

  gsap.from('.collection-frame > *', {y:30, opacity:0, duration:0.8, stagger:0.1, ease:'power3.out', scrollTrigger:{trigger:'.collection-strip', start:'top 85%', end:'top 55%', scrub:1}});

  const ritualEl = document.getElementById('ritual-timeline');
  const railPath = document.getElementById('ritualRailPath');
  const ritualNodes = ritualEl ? ritualEl.querySelectorAll('.ritual-node') : [];
  const ritualStars = seedStars('starLayerRitual', 8, [8,16], {xMin:2,xMax:98,yMin:5,yMax:90});

  if (ritualEl) {
    gsap.from(ritualEl.querySelector('.label'), {y:26, opacity:0, duration:0.8, ease:'power3.out', scrollTrigger:{trigger:ritualEl, start:'top 82%', toggleActions:'play none none none'}});
  }

  // Desktop and mobile need different triggers because the timeline changes from a row to a tall column.
  const mm = gsap.matchMedia();

  mm.add('(min-width: 901px)', () => {
    if (railPath && ritualEl) {
      const railLen = railPath.getTotalLength();
      gsap.set(railPath, {strokeDasharray:railLen, strokeDashoffset:railLen});
      gsap.to(railPath, {
        strokeDashoffset:0,
        ease:'none',
        scrollTrigger:{
          trigger:document.getElementById('ritualTrack') || ritualEl,
          start:'top 78%',
          end:'bottom 42%',
          scrub:0.6,
          invalidateOnRefresh:true
        }
      });
    }
    if (ritualEl) {
      gsap.from(ritualNodes, {y:30, opacity:0, scale:0.9, duration:0.8, stagger:0.15, ease:'back.out(1.6)', scrollTrigger:{trigger:ritualEl, start:'top 67%', end:'top 34%', scrub:0.7}});
      gsap.set(ritualStars, {opacity:0, scale:0});
      gsap.to(ritualStars, {opacity:()=>gsap.utils.random(0.2,0.45), scale:1, rotation:()=>gsap.utils.random(-60,60), duration:1, stagger:0.08, ease:'back.out(2)', scrollTrigger:{trigger:ritualEl, start:'top 65%', toggleActions:'play none none reverse'}});
    }
  });

  mm.add('(max-width: 900px)', () => {
    if (ritualEl) {
      gsap.from(ritualNodes, {
        y:36,
        opacity:0,
        duration:0.9,
        stagger:0.12,
        ease:'power3.out',
        scrollTrigger:{
          trigger:ritualEl,
          start:'top 78%',
          end:'bottom 36%',
          scrub:1,
          invalidateOnRefresh:true
        }
      });
      gsap.set(ritualStars, {opacity:0, scale:0});
      gsap.to(ritualStars, {opacity:()=>gsap.utils.random(0.2,0.45), scale:1, rotation:()=>gsap.utils.random(-60,60), duration:1, stagger:0.08, ease:'back.out(2)', scrollTrigger:{trigger:ritualEl, start:'top 65%', toggleActions:'play none none reverse'}});
    }
  });

  document.querySelectorAll('[data-product-world]').forEach((row) => {
    const imageWrap = row.querySelector('.world-image');
    const img = row.querySelector('.world-image img');
    const copy = row.querySelector('.world-copy');
    const copyChildren = copy ? Array.from(copy.children).filter(el => !el.classList.contains('texture') && !el.classList.contains('star-layer')) : [];
    const specBoxes = row.querySelectorAll('.spec-box');
    const fromX = row.classList.contains('reverse') ? 100 : -100;

    mm.add('(min-width: 901px)', () => {
      if (imageWrap) gsap.from(imageWrap, {x:fromX, opacity:0, duration:1.1, ease:'power4.out', scrollTrigger:{trigger:row, start:'top 78%', end:'top 38%', scrub:1}});
      if (copyChildren.length) gsap.from(copyChildren, {y:40, opacity:0, duration:0.9, stagger:0.06, ease:'power3.out', scrollTrigger:{trigger:row, start:'top 72%', end:'top 32%', scrub:1}});
      if (specBoxes.length) gsap.from(specBoxes, {scale:0.85, opacity:0, duration:0.7, stagger:0.08, ease:'back.out(1.6)', scrollTrigger:{trigger:row, start:'top 60%', end:'top 30%', scrub:1}});
    });

    mm.add('(max-width: 900px)', () => {
      if (imageWrap) {
        gsap.from(imageWrap, {
          x:fromX,
          opacity:0,
          duration:1.1,
          ease:'power4.out',
          scrollTrigger:{
            trigger:row,
            start:'top 82%',
            end:'top 42%',
            scrub:1,
            invalidateOnRefresh:true
          }
        });
      }
      if (copyChildren.length) {
        gsap.from(copyChildren, {
          y:40,
          opacity:0,
          duration:0.9,
          stagger:0.06,
          ease:'power3.out',
          scrollTrigger:{
            trigger:row,
            start:'top 76%',
            end:'bottom 34%',
            scrub:1,
            invalidateOnRefresh:true
          }
        });
      }
    });

    if (img) {
      const speed = parseFloat(img.dataset.parallaxImg || 0);
      gsap.to(img, {y:speed, ease:'none', scrollTrigger:{trigger:row, start:'top bottom', end:'bottom top', scrub:1, invalidateOnRefresh:true}});
    }
  });

  const gemsStars = seedStars('starLayerGems', 5, [10,18], {xMin:2,xMax:95,yMin:5,yMax:95});
  gsap.set(gemsStars, {opacity:0, scale:0});
  gsap.to(gemsStars, {opacity:()=>gsap.utils.random(0.2,0.45), scale:1, rotation:()=>gsap.utils.random(-60,60), duration:1, stagger:0.1, ease:'back.out(2)', scrollTrigger:{trigger:'#vitality-gems', start:'top 60%', end:'top 25%', scrub:1}});
  const elixirStars = seedStars('starLayerElixir', 5, [10,18], {xMin:2,xMax:95,yMin:5,yMax:95});
  gsap.set(elixirStars, {opacity:0, scale:0});
  gsap.to(elixirStars, {opacity:()=>gsap.utils.random(0.2,0.45), scale:1, rotation:()=>gsap.utils.random(-60,60), duration:1, stagger:0.1, ease:'back.out(2)', scrollTrigger:{trigger:'#dream-elixir', start:'top 60%', end:'top 25%', scrub:1}});

  gsap.from('.ce-inner .label, .ce-inner h2, .ce-lead', {y:36, opacity:0, duration:0.9, stagger:0.1, ease:'power3.out', scrollTrigger:{trigger:'.cellular-energy', start:'top 78%', end:'top 45%', scrub:1}});
  gsap.from('.chart-panel', {scale:0.96, opacity:0, duration:0.8, ease:'power3.out', scrollTrigger:{trigger:'.chart-panel', start:'top 82%', toggleActions:'play none none none', once:true}});
  const chartMM = gsap.matchMedia();
  const animateChartLines = (selector) => {
    document.querySelectorAll(selector).forEach((el)=>{
      const length = el.getTotalLength();
      gsap.set(el, {strokeDasharray:length, strokeDashoffset:length});
      gsap.to(el, {strokeDashoffset:0, duration:1.2, ease:'power2.out', scrollTrigger:{trigger:'.chart-panel', start:'top 72%', toggleActions:'play none none none', once:true}});
    });
  };
  chartMM.add('(min-width: 901px)', () => animateChartLines('.chart-svg-desktop [data-chart-line]'));
  chartMM.add('(max-width: 900px)', () => animateChartLines('.chart-svg-mobile [data-chart-line]'));
  gsap.from('.chart-legend', {opacity:0, y:16, duration:0.7, ease:'power3.out', scrollTrigger:{trigger:'.chart-panel', start:'top 55%', toggleActions:'play none none none', once:true}});
  gsap.from('.ce-point', {y:30, opacity:0, duration:0.8, stagger:0.1, ease:'power3.out', scrollTrigger:{trigger:'.ce-points', start:'top 88%', end:'top 60%', scrub:1}});
  const ceStars = seedStars('starLayerCE', 6, [10,20], {xMin:2,xMax:98,yMin:5,yMax:95});
  gsap.set(ceStars, {opacity:0, scale:0});
  gsap.to(ceStars, {opacity:()=>gsap.utils.random(0.2,0.45), scale:1, rotation:()=>gsap.utils.random(-60,60), duration:1, stagger:0.1, ease:'back.out(2)', scrollTrigger:{trigger:'.cellular-energy', start:'top 60%', end:'top 25%', scrub:1}});

  gsap.from('.philosophy .label, .philosophy blockquote, .pillar', {y:36, opacity:0, duration:0.9, stagger:0.08, ease:'power3.out', scrollTrigger:{trigger:'.philosophy', start:'top 75%', end:'top 40%', scrub:1}});

  const postedSuccess = new URLSearchParams(window.location.search).get('customer_posted') === 'true';
  if (!postedSuccess) {
    gsap.from('.waitlist .sparkle, .waitlist .label, .waitlist h2, .waitlist p, .waitlist-form, .waitlist .fine', {y:36, opacity:0, duration:0.9, stagger:0.08, ease:'power3.out', scrollTrigger:{trigger:'.waitlist', start:'top 75%', end:'top 35%', scrub:1}});
  } else {
    // Shopify reloads directly at #contact_form after a successful submit. Do not replay a scrubbed entrance there.
    gsap.set('.waitlist .sparkle, .waitlist .label, .waitlist h2, .waitlist p, .waitlist-form, .waitlist .fine', {clearProps:'all', opacity:1, y:0});
  }
  const wlStars = seedStars('starLayerWaitlist', 7, [10,18], {xMin:5,xMax:95,yMin:5,yMax:90});
  gsap.set(wlStars, {opacity:0, scale:0});
  gsap.to(wlStars, {opacity:()=>gsap.utils.random(0.2,0.5), scale:1, rotation:()=>gsap.utils.random(-60,60), duration:1.2, stagger:0.07, ease:'back.out(2)', scrollTrigger:{trigger:'.waitlist', start:'top 70%', end:'top 30%', scrub:1}});

  // iOS/Chrome/Safari can change the visual viewport after the first paint. Recalculate triggers after assets settle.
  const refresh = () => ScrollTrigger.refresh(true);
  window.addEventListener('load', refresh, {once:true});
  window.addEventListener('orientationchange', () => setTimeout(refresh, 250));
  if (window.visualViewport) window.visualViewport.addEventListener('resize', () => setTimeout(refresh, 120));
  document.querySelectorAll('img').forEach(img => {
    if (!img.complete) img.addEventListener('load', refresh, {once:true});
  });
  setTimeout(refresh, 300);
});
